import { addLanguageToPath, extractLanguageFromPath } from "./languageCore";

const mergeParams = (param1: string, param2: string) => {
  const searchParam1 = new URLSearchParams(param1);
  const searchParam2 = new URLSearchParams(param2);
  const finalParam = new URLSearchParams();

  for (const [key, value] of searchParam1?.entries()) {
    finalParam.append(key, value);
    if (searchParam2.get(key)) {
      if (searchParam2.get(key) === searchParam1.get(key)) {
        searchParam2.delete(key);
      } else {
        finalParam.append(key, searchParam2.get(key) || "");
        searchParam2.delete(key);
      }
    }
  }

  for (const [key, value] of searchParam2?.entries()) {
    finalParam.append(key, value);
  }

  return finalParam.toString();
};

const urlBuilder = (
  paths: any,
  options: { params?: any; protocol?: any } = {},
  donotAddLang = false,
) => {
  if (typeof paths == "string") {
    paths = [paths];
  }

  let initPath = paths.join("/");
  const { params } = options;

  const param1 = initPath.split("?")?.[1];
  initPath = initPath.split("?")?.[0];
  const param2 = new URLSearchParams(params).toString();

  const searchParam = mergeParams(param1, param2);

  // Add language prefix if current URL has one and the new path doesn't
  if (typeof window !== "undefined") {
    const currentLanguage = extractLanguageFromPath(window.location.pathname);
    const pathHasLanguage = extractLanguageFromPath(initPath);

    // If current page has language prefix and new path doesn't, add it
    if (currentLanguage && !pathHasLanguage && !donotAddLang) {
      // Preserve trailing slash if present
      const hasTrailingSlash = initPath.endsWith("/") && initPath.length > 1;
      initPath = addLanguageToPath(initPath, currentLanguage, hasTrailingSlash);
    }
  }
  // Remove double slashes (except after protocol)
  initPath = initPath.replace(/([^:]\/)\/+/g, "$1");

  let newUrl: any = `${initPath}${searchParam ? `?${searchParam}` : ""}`;

  if (options.protocol) {
    try {
      newUrl = new URL(newUrl);
      newUrl.protocol = options.protocol;
      newUrl = newUrl.href;
    } catch (e) {
      console.error(e);
    }
  }

  return newUrl;
};

export default urlBuilder;
